import React from "react";
import ReactDOM from "react-dom";

import Rotas from "./Rotas";
import { Roteador } from "@intechprev/componentes-web";
import { HashRouter } from "react-router-dom";

ReactDOM.render(
  <HashRouter>
    <Roteador rotas={[...Rotas]} />
  </HashRouter>, document.getElementById('root')
);